import React from "react";
import { Link } from "react-router-dom";

interface MenuCategoryLinkProps {
  to: string;
  children: string;
  isActive?: boolean;
  variant?: "menu" | "location";
  showDivider?: boolean;
}

const MenuCategoryLink: React.FC<MenuCategoryLinkProps> = ({
  to,
  children,
  isActive = false,
  variant = "menu",
  showDivider = false,
}) => {
  const className =
    variant === "menu"
      ? `menu-cat-link ${isActive ? "active" : ""}`
      : "menu-category-link";

  return (
    <>
      <Link to={to} className={className}>
        {children}
      </Link>
      {showDivider && <span className="menu-cat-divider">|</span>}
    </>
  );
};

export default MenuCategoryLink;
